/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */
import type { Polygon } from 'geojson'

export const nldnBoundaryPolygon: Polygon = {
	type: 'Polygon',
	coordinates: [
		[
			[-103.2, 28.5],
			[-100.927_03, 28.504_77],
			[-100.282_86, 28.032_22],
			[-99, 26.3],
			[-98.372_03, 25.6141],
			[-97.744_39, 25.140_94],
			[-96.930_37, 25.140_94],
			[-96.302_73, 25.6141],
			[-96.153_53, 26.3426],
			[-95.250_64, 28.795_54],
			[-92.507_56, 28.958_56],
			[-91.725_49, 28.709_43],
			[-91.080_06, 28.236_92],
			[-90.243_75, 28.236_92],
			[-89.598_32, 28.709_43],
			[-85.765_63, 29.298_37],
			[-85.116_49, 28.825_99],
			[-83.728_47, 27.3634],
			[-83.158_91, 26.110_62],
			[-82.5286, 25.637_56],
			[-81.528_05, 24.963_13],
			[-80.9038, 24.489_84],
			[-80.094_03, 24.489_84],
			[-79.469_78, 24.963_13],
			[-79.321_58, 25.691_73],
			[-79.560_49, 27.249_41],
			[-79.408_62, 27.977_66],
			[-79.821_09, 28.622_07],
			[-80.155_26, 31.440_49],
			[-78.284_29, 32.7981],
			[-77.607_01, 33.269_58],
			[-75.251_86, 34.900_93],
			[-74.557_28, 35.3719],
			[-74.388_52, 36.098_76],
			[-74.339_95, 37.307_45],
			[-74.166_08, 38.033_95],
			[-73.461_62, 38.970_06],
			[-73.282_93, 39.696_24],
			[-71.220_13, 41.3474],
			[-70, 41.25],
			[-68.186_12, 43.167_17],
			[-66.634_51, 42.872_12],
			[-65.629_97, 42.872_12],
			[-64.850_61, 43.340_94],
			[-55.67, 46.7],
			[-53.317_13, 46.497_64],
			[-52.247_89, 46.497_64],
			[-51.416_94, 46.965_35],
			[-51.208_22, 47.689_87],
			[-51.742_13, 48.335_31],
			[-52.948_62, 49.122_81],
			[-53.497_06, 49.768_41],
			[-53.893_83, 51.543_68],
			[-54.469_54, 52.189_58],
			[-55.061_58, 52.211_71],
			[-55.805_99, 51.818_28],
			[-56.518_56, 51.508_47],
			[-57.130_89, 51.253_98],
			[-57.128_85, 51.984_57],
			[-63.859_06, 51.973_447],
			[-68.650_45, 54.975_92],
			[-72.487_49, 54.576_95],
			[-73.680_33, 54.834_99],
			[-75.878_22, 55.449_14],
			[-76.506_68, 56.095_68],
			[-77.746_04, 56.354],
			[-78.9854, 56.095_68],
			[-79.613_87, 55.449_14],
			[-83.568_07, 55.186_55],
			[-84.192_59, 55.833_04],
			[-85.423_58, 56.091_31],
			[-86.654_58, 55.833_04],
			[-87.2791, 55.186_55],
			[-88.697_03, 54.635_87],
			[-89.891_59, 54.893_92],
			[-92.783_52, 56.531_19],
			[-92.307_72, 58.187_88],
			[-92.023_53, 58.909_65],
			[-92.710_42, 59.556_96],
			[-94.074_61, 59.816_03],
			[-95.4388, 59.556_96],
			[-97.137_74, 59.527_42],
			[-98.500_73, 59.786_48],
			[-99.863_73, 59.527_42],
			[-100.550_07, 58.880_11],
			[-103.754_81, 59.425_86],
			[-104.451_59, 60.073_31],
			[-105.837_04, 60.3325],
			[-107.2225, 60.073_31],
			[-107.919_28, 59.425_86],
			[-109.935_62, 57.468_79],
			[-111.2211, 57.727_38],
			[-112.506_58, 57.468_79],
			[-115.119_13, 58.802_31],
			[-115.804_01, 59.449_59],
			[-117.163_87, 59.708_63],
			[-118.523_73, 59.449_59],
			[-120.795_12, 58.095_46],
			[-127.232_35, 56.102_62],
			[-130.007_07, 55.0392],
			[-131.236_18, 54.115_49],
			[-130.275_83, 52.700_16],
			[-127.626_49, 50.553_02],
			[-127.403_29, 49.829_15],
			[-126.144_21, 48.113_97],
			[-125.933_49, 47.389_54],
			[-125.431_28, 44.778_12],
			[-125.235_02, 44.052_97],
			[-125.578_95, 42.090_75],
			[-125.392_56, 41.365_04],
			[-124.637_49, 40.895_65],
			[-123.626_71, 38.3994],
			[-123.451_81, 37.672_97],
			[-122.736_11, 37.202_59],
			[-121.983_38, 35.881_53],
			[-121.815_17, 35.154_63],
			[-121.122_46, 34.6836],
			[-120.5, 34],
			[-118.358_46, 32.809_23],
			[-117.684_73, 32.337_64],
			[-116.812_88, 32.337_64],
			[-115.720_96, 32.1045],
			[-115.052_52, 31.632_75],
			[-114.187_31, 31.632_75],
			[-112.078_86, 30.974_91],
			[-111.418_51, 30.5029],
			[-110.563_47, 30.5029],
			[-109.903_12, 30.974_91],
			[-108.2, 31.2],
			[-106.892_62, 30.716_61],
			[-106.234_06, 30.244_54],
			[-105.381_26, 30.244_54],
			[-103.2, 28.5],
		],
	],
}
